import type { ComponentProps, ReactNode } from "react";

/** C composition roles. These components render identity and actions, never money state. */
export function TabHeader({ title, children }: { title: string; children: ReactNode }) {
  return <header className="cc-header"><h1>{title}</h1><div className="cc-header-actions">{children}</div></header>;
}

export function InboxHeader(props: { title: string; children: ReactNode }) {
  return <TabHeader {...props} />;
}

export function PersonalAvatar({ initial, label, className = "", ...props }: ComponentProps<"button"> & { initial: string; label: string }) {
  return <button {...props} type="button" className={`cc-personal-avatar ${className}`} aria-label={label}><span aria-hidden="true">{initial}</span></button>;
}
